<template>
  <Dialog 
    :name="name"
    :dialogClass="dialogClass"
    :value="value"
    :hasClose="false"
    :maskClickClose="false"
    :hasCancel="type === 'confirm'"
    :handleOk="handleOk"
    :handleCancel="handleCancel"
    :center="center"
    :verticalCenter="verticalCenter"
    :okText="okText"
    :cancelText="cancelText"
    :okBtnColor="okBtnColor"
    :cancelBtnColor="cancelBtnColor"
    :width="width"
    :top="top"
    :loading="loading"
  >
    <div slot="header" v-html="title"></div>
    <div class="gkui-confirm-content">
      <p v-for="(label, index) in text" :key="index">{{label}}</p>
    </div>
  </Dialog>
</template>
<script>
import VueTypes from 'vue-types'
import ModalPlugin from '../modal'
import Dialog from './Dialog'
export default {
  name: 'gkui-confirm',
  components: {
    Dialog
  },
  props: {
    title: VueTypes.string,
    message: VueTypes.oneOfType([String, Array]).def(''),
    type: VueTypes.string.def('message'),
    dialogClass: VueTypes.string.def('gkui-dialog-confirm'),
    value: VueTypes.bool.def(false),
    center: VueTypes.bool.def(false),
    verticalCenter: VueTypes.bool.def(false),
    name: VueTypes.string,
    width: VueTypes.number.def(412),
    top: VueTypes.oneOfType([Number, String]).def(100),
    okText: VueTypes.string.def('确定'),
    cancelText: VueTypes.string.def('取消'),
    okBtnColor: VueTypes.string.def('blue'),
    cancelBtnColor: VueTypes.string.def('transparent'),
    loading: VueTypes.bool.def(false),
    autoClose: VueTypes.bool.def(false)
  },
  computed: {
    text () {
      return Array.isArray(this.message) ? this.message : [this.message]
    }
  },
  methods: {
    /**
     * 确定按钮的回调函数
     * 返回 true 时弹出框会关闭
     */
    handleOk ({clear, close}) {
      if (this.autoClose) {
        close && close()
        return true
      }

      ModalPlugin.event.$emit('closeMessage', {ok: true, clear, close})
      return true
    },
    /**
     * 取消按钮的回调函数
     * 返回 true 时弹出框会关闭
     */
    handleCancel ({close}) {
      if (this.autoClose) {
        close && close()
        return true
      }

      ModalPlugin.event.$emit('closeMessage', {ok: false, close})
      return true
    }
  }
}
</script>
